import React, { PropTypes } from 'react';

const InfoIcon = ({ infoMessage }) => (
  <span className="fa info-icon" data-tip={infoMessage} data-for="infoIcon">
    <i className="fa fa-info-circle" />
  </span>
);

InfoIcon.propTypes = {
  infoMessage: PropTypes.string.isRequired,
};

export default InfoIcon;
